module.exports = __webpack_public_path__ + "static/media/figtree-latin-ext-500.a72ebafb.woff2";